import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import ImpressumSectionHeadersWhitePattern1 from '../components/headers-white-pattern/ImpressumSectionHeadersWhitePattern1';
import ImpressumSectionFootersGrayPattern2 from '../components/footers-gray-pattern/ImpressumSectionFootersGrayPattern2';

const meta = {
  title: '',
  meta: [],
  link: [],
  style: [],
  script: [],
};

export default function Impressum() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <ImpressumSectionHeadersWhitePattern1 />
      <ImpressumSectionFootersGrayPattern2 />
    </React.Fragment>
  );
}

